import { render, staticRenderFns } from "./UserDetailsTable.vue?vue&type=template&id=479173ed&lang=pug&"
import script from "./UserDetailsTable.vue?vue&type=script&lang=js&"
export * from "./UserDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports